<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small">
    <el-row>
      <el-form-item class="select_btn_190" prop="deptLevelCodes">
        <el-input clearable placeholder="请选择工作单位" v-model="filters.deptNames" @focus="showDeptModal"
          @clear="clearDepts">
        </el-input>
        <!-- <el-cascader
          clearable
          :props="props"
          collapse-tags
          v-model="filters.deptLevelCodes"
          placeholder="工作单位"
        /> -->
      </el-form-item>
      <el-form-item class="select_btn">
        <el-select class="select_btn_style" v-model="filters.leaderType" placeholder="管理主体">
          <el-option v-for="(item, i) in leaderTypeData" :key="i" :label="item.paramValue"
            :value="item.paramKey"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn_160">
        <el-select clearable multiple collapse-tags class="select_btn_style" v-model="filters.cadreLevels"
          placeholder="干部级别（多选）">
          <el-option v-for="(item, i) in cadreLevelData" :key="i" :label="item.paramValue"
            :value="item.paramKey"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn">
        <el-select class="select_btn_style" v-model="filters.userStatus" placeholder="用户状态">
          <el-option v-for="(item, i) in userStatusData" :key="i" :label="item.paramValue"
            :value="item.paramKey"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn">
        <!-- <el-cascader
          ref="trainType"
          class="select_btn_style"
          v-model="filters.trainType"
          :options="trainTypeData"
          :props="propsType"
          collapse-tags
          placeholder="培训类型"
        >
        </el-cascader> -->
        <el-select class="select_btn_style" v-model="filters.onlineCode" placeholder="培训码">
          <el-option v-for="(item, i) in codeData" :key="i" :label="item.paramValue" :value="item.paramKey"></el-option>

        </el-select>
      </el-form-item>
      <el-form-item class="select_btn">
        <el-select class="select_btn_style" v-model="filters.isExam" placeholder="考核状态">
          <el-option v-for="(item, i) in publicData" :key="i" :label="item.paramValue"
            :value="item.paramKey"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="select_btn_160" v-if="filters.isExam == 1">
        <el-select class="select_btn_style" v-model="filters.isUpToStandard" placeholder="网络培训是否达标">
          <el-option v-for="(item, i) in onlineData" :key="i" :label="item.paramValue"
            :value="item.paramKey"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-show="showMore" class="m-l-14">
        <el-input prefix-icon="el-icon-search" size="small" v-model.trim="filters.userName" placeholder="姓名"></el-input>
      </el-form-item>
      <el-form-item v-show="showMore" class="m-l-14">
        <el-input prefix-icon="el-icon-search" size="small" v-model.trim="filters.userMobile"
          placeholder="手机号"></el-input>
      </el-form-item>
      <el-form-item label="提任处级年月：" v-show="showMore">
        <el-date-picker class="date-picker" value-format="yyyy-MM" size="small" v-model="filters.promoteSectionDate"
          type="monthrange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" unlink-panels>
        </el-date-picker>
      </el-form-item>

      <el-form-item v-show="!showMore" class="m-l-14">
        <butn btntype="primary" title="查询" @click="initData"></butn>
        <butn title="重置" @click="resetData" class="czButn"></butn>
        <butn title="展开" iconName="el-icon-arrow-down" @click="showMore = true" class="czButn"></butn>
      </el-form-item>
    </el-row>

    <el-row v-show="showMore">
      <el-form-item label="出生年月：">
        <el-date-picker class="date-picker" value-format="yyyy-MM" size="small" v-model="filters.birthTime"
          type="monthrange" range-separator="至" start-placeholder="开始年月" end-placeholder="结束年月" unlink-panels>
        </el-date-picker>
      </el-form-item>
      <el-form-item label="学习时间：">
        <el-date-picker class="studyYearPicker" v-model="filters.studyYear" type="year" :editable="false"
          :clearable="false" :picker-options="studyYearOptions" value-format="yyyy" placeholder="选择年" @change="studyYearChange">
        </el-date-picker>
        <el-date-picker v-if="showStudyTime()" class="date-picker" value-format="yyyy-MM-dd" size="small"
          v-model="filters.studyTime" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" :picker-options="pickerOptions" @change="changeStudyTime">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="网络培训学时：" class="m-l-14">
        <el-input class="credit-input" v-model="filters.startOnlineLength" oninput="value=value.replace(/[^0-9.]/g,'')"
          @input="handleInput($event, 'startOnlineLength')">
        </el-input><span class="sepertor">至</span>
        <el-input class="credit-input" v-model="filters.endOnlineLength" oninput="value=value.replace(/[^0-9.]/g,'')"
          @input="handleInput($event, 'endOnlineLength')">
        </el-input>
      </el-form-item>

      <el-form-item class="m-l-14">
        <butn btntype="primary" title="查询" @click="initData"></butn>
        <butn title="重置" @click="resetData" class="czButn"></butn>
        <butn title="收起" iconName="el-icon-arrow-up" @click="showMore = false" class="czButn"></butn>
      </el-form-item>
    </el-row>
    <SearchLazyTree ref="lazyTree" showTooltip :deptDialog="deptDialog" @selectDept="selectDept" />
  </el-form>
</template>

<script>
import { treeChildVos } from "@/api/classOffline";
import { getSysParamByTypes } from "@/api/sysParam";
import butn from "@/components/button/index";
import SearchLazyTree from "@/components/tree/searchLazyTree.vue";
import moment from "moment";

export default {
  components: { butn, SearchLazyTree },
  data() {
    return {
      deptDialog: {
        flag: false
      },
      defaultCheckedKeys: [],
      filters: {
        startTime: null,
        endTime: null,
        studyYear: String(new Date().getFullYear()),
        studyTime: [],
        isUpToStandard: null,
        isExam: '1',
        deptNames: "",
        deptLevelCodes: [],
      },
      isOverYear: false,
      leaderTypeData: [],
      trainTypeData: [],
      userStatusData: [],
      publicData: [],
      codeData: [],
      onlineData: [],
      cadreLevelData: [],
      showMore: false,
      props: {
        //树形
        label: "deptName",
        children: "zones",
        isLeaf: function (data, node) {
          return !data.hasChildren
        },
      },
      pickerOptions: {
        disabledDate: (time) => {
          let curDate = (new Date()).getTime()
          const currentYear = new Date().getFullYear();
          const timeYear = time.getFullYear();
          const minYear = this.filters.studyYear
          if (minYear == currentYear) { 
            return time.getTime() > curDate || timeYear != minYear;
          } else {
            return timeYear != minYear
          }
        },
      },
      studyYearOptions: {
        disabledDate: (time) => {
          const date = new Date();
          const year = date.getFullYear();
          const timeyear = time.getFullYear();
          return timeyear < year - 5 || timeyear > year;
        },
      },
    };
  },
  created() {
    this.getTrainTypeList();
    this.getSysParamByTypes(["USER_LEADER_TYPE", "USER_STATUS", "EXAM_STATUS", "ONLINE_CODE", "IS_UP_TO_STANDARD", "CADRE_LEVEL"]);

    this.$nextTick(() => {
      // const { deptLevelCode } = this.$route.query;
      // let deptLevelCodes = null;
      // if (deptLevelCode) {
      //   deptLevelCodes = deptLevelCode.split(",");
      // }
      this.initStudyTime();
    })
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        res.data["USER_LEADER_TYPE"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        res.data["USER_STATUS"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        res.data["EXAM_STATUS"].splice(0, 0, { paramKey: "", paramValue: "全部用户" });
        res.data["ONLINE_CODE"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        res.data["IS_UP_TO_STANDARD"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        this.leaderTypeData = res.data["USER_LEADER_TYPE"];
        this.userStatusData = res.data["USER_STATUS"];
        this.publicData = res.data["EXAM_STATUS"];
        this.codeData = res.data["ONLINE_CODE"];
        this.onlineData = res.data["IS_UP_TO_STANDARD"];
        this.cadreLevelData = res.data["CADRE_LEVEL"];
      });
    },
    getTrainTypeList() {
      treeChildVos({ type: "CLASS_TYPE_DOWN" }).then((res) => {
        let goal = [];
        if (!res || res.code != 0) return;
        goal = res.data;
        this.trainTypeData = goal;
      });
    },
    initData(deptLevelCodes = []) {
      if (
        this.filters.startOnlineLength >= 0 &&
        this.filters.endOnlineLength >= 0
      ) {
        if (
          parseInt(this.filters.startOnlineLength) >
          parseInt(this.filters.endOnlineLength)
        ) {
          this.$message({
            message: "请输入正确的学时区间(结束学时应大于等于开始学时)",
            type: "warning",
          });
          return;
        }
      }

      let params = { ...this.filters };
      if (deptLevelCodes && deptLevelCodes.length > 0) {
        params.deptLevelCodes = deptLevelCodes;
      }
      delete params.birthTime;
      delete params.studyTime;
      delete params.promoteSectionDate;
      if (this.filters.birthTime && this.filters.birthTime.length > 1) {
        params["birthDayStart"] = this.filters.birthTime[0];
        params["birthDayEnd"] = this.filters.birthTime[1];
      }
      if (this.showStudyTime() && this.filters.studyTime && this.filters.studyTime.length > 1) {
        params["startTime"] = moment(this.filters.studyTime[0]).format("YYYY-MM-DD");
        params["endTime"] = moment(this.filters.studyTime[1]).format("YYYY-MM-DD");
      }
      if (this.filters.promoteSectionDate && this.filters.promoteSectionDate.length > 1) {
        params["promoteDateStart"] = this.filters.promoteSectionDate[0];
        params["promoteDateEnd"] = this.filters.promoteSectionDate[1];
      }
      this.$emit("search", params);
      this.$emit("overYear", this.isOverYear);
    },
    resetData() {
      this.filters = this.$options.data().filters;
      // 设置级联默认值
      this.defaultCheckedKeys = [];
      this.$nextTick(() => {
        if (this.$refs.lazyTree && this.$refs.lazyTree.$refs["tree"]) {
          this.$refs.lazyTree.$refs["tree"].setCheckedKeys(this.defaultCheckedKeys);
        }
      })
      this.initStudyTime();
      console.log("重置", this.filters);
      this.initData();
    },
    handleInput(value, name) {
      if (value != "") {
        if (value.indexOf(".") > -1) {
          this.filters[name] = value.slice(0, value.indexOf(".") + 3);
        } else {
          this.filters[name] = value;
        }
      }
    },

    initStudyTime() {
      let nowDate = new Date();
      let year = nowDate.getFullYear() + '';
      let month = nowDate.getMonth() + 1;
      let day = nowDate.getDate();
      let studyTime = [`${year}-01-01`, `${year}-${month}-${day}`];
      this.$set(this.filters, 'studyYear', year);
      this.$set(this.filters, 'studyTime', studyTime);
    },
    /**
     * 选择学习时间
     */
    changeStudyTime(val) {
      // 判断有没有跨年。      
      let preYear = this.getDateStrYear(val[0]);
      let afterYear = this.getDateStrYear(val[1]);
      let flag = false
      if (preYear != afterYear) {
        flag = true;
        this.$message({
          showClose: true,
          message: '学习时间跨年后，无法显示培训码相关指标',
          type: 'warning',
          duration: 5000
        });
      }
      this.isOverYear = flag
    },
    getDateStrYear(dateStr) {
      if (dateStr) {
        let list = dateStr.split('-');
        if (list && list.length > 0) {
          return parseInt(list[0]);
        }
      }
      return '';
    },

    // 选择工作单位弹窗
    showDeptModal() {
      this.deptDialog.flag = true;
    },
    clearDepts() {
      this.defaultCheckedKeys = [];
      this.filters.deptLevelCodes = [];
      this.$nextTick(() => {
        this.$refs.lazyTree.$refs["tree"].setCheckedKeys(this.defaultCheckedKeys);
      })
    },
    // 工作单位选择确定
    selectDept(data) {
      this.filters.deptLevelCodes = data.deptLevelCodes;
      this.defaultCheckedKeys = data.nodeKeys;
      this.deptDialog.flag = false;
    },
    showStudyTime() {
      const nowDate = new Date();
      const currentYear = nowDate.getFullYear()
      return this.filters.studyYear > currentYear - 2;
    },
    studyYearChange() {
      const currentYear = new Date().getFullYear()
      const studyYear = this.filters.studyYear;
      if (studyYear == currentYear) {
        this.initStudyTime();
      } else if (studyYear == currentYear - 1) {
        let studyTime = [`${studyYear}-01-01`, `${studyYear}-12-31`];
        this.$set(this.filters, 'studyTime', studyTime);
      } else {
        this.filters.studyTime = [];
      }
    },
  },
};
</script>
<style>
/**
* hack: 解决ie浏览器 标签一行展示不下时 抖动
 */
.hack_w_300 {
  width: 300px;
}

.hack_w_300 .el-cascader {
  width: 290px;
}
</style>

<style lang="scss" scoped>
$color: #d7dbe0;
$border-radius: 2px;

.serach-form {

  .studyYearPicker {
    width: 100px !important;
  }

  text-align: left;

  & /deep/ .none-margin-right {
    margin-right: 0;
  }

  /deep/ .credit-input {
    width: 60px;
    // border-radius: 2px;
    // border: 1px solid #dcdfe6;
    height: 30px;
    // color: #606266;
    // outline: none;
    // -webkit-appearance: none;
    // background-color: #ffffff;
    // background-image: none;
    // padding: 0 10px;
    // &:focus {
    //   border-color: #3a85ff;
    // }
  }

  .credit-study-time {
    height: 30px;
    display: flex;
    flex-direction: row;

    & /deep/ .study-time {
      width: 110px;
    }

    & /deep/ .date-picker {
      width: 240px;
    }
  }

  .sepertor {
    margin: 0 10px;
  }
}
</style>